import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
interface Props {
  action: string;
  subject: string;
  children: any;
  ability: any;
}
const ProtectedRoute = ({ action, subject, children, ability }: Props) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!ability.can(action, subject)) {
      navigate('/unauthorized');
    }
  }, []);

  return children;
};

export default ProtectedRoute;
